import { AuthPermission } from './auth-permission';
import { AccessPolicy } from './auth.guards';

export interface AuthAccess {
  isAuthenticated(): boolean;
  hasAnyPermission(permissions: Iterable<AuthPermission>): boolean;
}

export const APP_ACCESS_PERMISSIONS: readonly AuthPermission[] = [
  AuthPermission.GlobalAdmin,
  AuthPermission.ComputoMetricoAccess,
];

export const APP_MANAGE_PERMISSIONS: readonly AuthPermission[] = [
  AuthPermission.GlobalAdmin,
  AuthPermission.ComputoMetricoManage,
];

export const APP_ADMIN_PERMISSIONS: readonly AuthPermission[] = [
  AuthPermission.GlobalAdmin,
  AuthPermission.ComputoMetricoAdmin,
];

export const AUTH_POLICIES = {
  access: {
    permissions: APP_ACCESS_PERMISSIONS,
    permissionMatch: 'any',
  },
  manage: {
    permissions: APP_MANAGE_PERMISSIONS,
    permissionMatch: 'any',
  },
  admin: {
    permissions: APP_ADMIN_PERMISSIONS,
    permissionMatch: 'any',
  },
} as const satisfies Record<string, AccessPolicy>;

export function homeForSession(session: AuthAccess): string {
  if (!session.isAuthenticated()) {
    return '/login';
  }
  if (session.hasAnyPermission(APP_ACCESS_PERMISSIONS)) {
    return '/computo-metrico';
  }
  if (session.hasAnyPermission(APP_ADMIN_PERMISSIONS)) {
    return '/amministrazione/utenti';
  }
  return '/access-denied';
}

export function canAccessUrl(session: AuthAccess, url: string): boolean {
  if (!session.isAuthenticated()) {
    return false;
  }

  const path = url.split(/[?#]/, 1)[0];
  if (path === '/change-password') {
    return true;
  }
  if (path === '/amministrazione/utenti' || path.startsWith('/amministrazione/utenti/')) {
    return session.hasAnyPermission(APP_ADMIN_PERMISSIONS);
  }
  if (path === '/computo-metrico/create' || path.startsWith('/computo-metrico/create/')) {
    return (
      session.hasAnyPermission(APP_ACCESS_PERMISSIONS) &&
      session.hasAnyPermission(APP_MANAGE_PERMISSIONS)
    );
  }
  if (path === '/computo-metrico' || path.startsWith('/computo-metrico/')) {
    return session.hasAnyPermission(APP_ACCESS_PERMISSIONS);
  }
  return false;
}
